import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Fetch a branded PDF from the backend and trigger a browser download.
 * Requires the member auth token. Throws on error.
 */
export async function downloadPdf({ title, kicker, meta, blocks, filename }) {
  const token = localStorage.getItem("astoria_member_token");
  if (!token) throw new Error("Not authenticated");
  const res = await axios.post(
    `${API}/pdf/generate`,
    { title, kicker, meta, blocks },
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    }
  );
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename || (title || "astoria-briefing").replace(/\s+/g, "-") + ".pdf";
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
